import { Link } from "react-router-dom";

type TabValue = "purpose" | "leadership" | "careers";

interface CompanyTabsProps {
  currentTab: TabValue;
}

export function CompanyTabs({ currentTab }: CompanyTabsProps) {
  const tabs: { value: TabValue; label: string }[] = [
    { value: "purpose", label: "Our Purpose" },
    { value: "leadership", label: "Leadership" },
    { value: "careers", label: "Careers" },
  ];

  return (
    <div className="w-full">
      <div className="inline-flex h-auto items-center gap-1 rounded-none border-b border-[#EDEBE4] bg-transparent p-0">
        {tabs.map((tab) => (
          <Link
            key={tab.value}
            to={`/company/${tab.value}`}
            className="min-h-[44px] rounded-none border-b-2 border-transparent bg-transparent px-4 py-2.5 text-sm font-semibold text-[#667085] transition-none hover:text-[#1F2A3A] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#1F2A3A]"
            style={{
              borderColor: currentTab === tab.value ? "#BC0319" : "transparent",
              color: currentTab === tab.value ? "#1F2A3A" : "#667085",
            }}
          >
            {tab.label}
          </Link>
        ))}
      </div>
    </div>
  );
}
